import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Users, Award, Clock, Globe } from 'lucide-react';
import '../styles/Pages.css';
import {Link} from 'react-router-dom';

const About = () => {
  return (
    <div className="page-container">
      <Header scrolled={true} />
      
      <main className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1>Sobre Nosotros</h1>
            <p>Conoce más sobre VillaTracking y nuestra misión de transformar la gestión de flotas vehiculares</p>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="page-grid">
              <div className="page-text">
                <h2>Nuestra Historia</h2>
                <p>VillaTracking nació en 2022 con una misión clara: revolucionar la forma en que las empresas gestionan sus flotas vehiculares. Fundada por un equipo de expertos en tecnología y logística, nuestra empresa ha crecido hasta convertirse en un referente en el sector de rastreo vehicular en Latinoamérica.</p>
                <p>Desde nuestros inicios, nos hemos comprometido con la innovación constante y el desarrollo de soluciones que realmente respondan a las necesidades de nuestros clientes. Hoy, contamos con un equipo de profesionales dedicados a ofrecer el mejor servicio y la tecnología más avanzada.</p>
              </div>
              <div className="page-image">
                <img src="img/about1.webp" alt="Equipo VillaTracking" />
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-section page-section-alt">
          <div className="container">
            <h2 className="text-center">Nuestros Valores</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">
                  <Award size={32} />
                </div>
                <h3>Excelencia</h3>
                <p>Nos esforzamos por superar las expectativas en todo lo que hacemos, desde el desarrollo de productos hasta el servicio al cliente.</p>
              </div>
              
              <div className="value-card">
                <div className="value-icon">
                  <Users size={32} />
                </div>
                <h3>Colaboración</h3>
                <p>Trabajamos estrechamente con nuestros clientes para entender sus necesidades y desarrollar soluciones personalizadas.</p>
              </div>
              
              <div className="value-card">
                <div className="value-icon">
                  <Clock size={32} />
                </div>
                <h3>Innovación</h3>
                <p>Constantemente buscamos nuevas formas de mejorar nuestros productos y servicios para mantenernos a la vanguardia tecnológica.</p>
              </div>
              
              <div className="value-card">
                <div className="value-icon">
                  <Globe size={32} />
                </div>
                <h3>Responsabilidad</h3>
                <p>Nos comprometemos con prácticas empresariales éticas y sostenibles que beneficien a nuestros clientes, empleados y al medio ambiente.</p>
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="page-grid">
              <div className="page-image">
                <img src="img/about2.jpeg" alt="Misión VillaTracking" />
              </div>
              <div className="page-text">
                <h2>Nuestra Misión y Visión</h2>
                <h3>Misión</h3>
                <p>Proporcionar soluciones de rastreo y gestión de flotas innovadoras y confiables que permitan a las empresas optimizar sus operaciones, reducir costos y mejorar la seguridad de sus activos.</p>
                <h3>Visión</h3>
                <p>Ser reconocidos como el líder global en soluciones de gestión de flotas, estableciendo nuevos estándares de excelencia e innovación en la industria.</p>
              </div>
            </div>
          </div>
        </section>
        
        <section className="page-cta">
          <div className="container">
            <h2>¿Listo para transformar la gestión de tu flota?</h2>
            <p>Únete a cientos de empresas que ya confían en VillaTracking</p>
            <Link to="/#contact" className="btn btn-primary btn-lg">
              Contáctanos Hoy
            </Link>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default About;